// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8845) return "static/chunks/8845.2dc6ac8030f2a4ed.js";
	if (chunkId === 1348) return "static/chunks/1348.1f66a9517e9b3c4c.js";
	if (chunkId === 7664) return "static/chunks/7664.a553c5f18379b4b2.js";
	if (chunkId === 1567) return "static/chunks/1567.148d2535f6ecc525.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"531":"01c2b776991fcf80","4669":"628aaaae644f1eff","5552":"af592b50c8dcc020","5600":"a3b15aeb4c2624a5","6580":"c80a3925ef16bf06","7370":"4324fa08155fca45","7458":"62a9bab224aa4d1f","8873":"58cf71afd28d2656"}[chunkId] + ".js";
};